import PropTypes from "prop-types";

DashboardHeader.propTypes = {
  onClickCollapse: PropTypes.func.isRequired,
};

export default function DashboardHeader({
  onClickCollapse,
  displayName,
  logout,
}) {
  return (
    <div className="layout-header">
      <div className="navbar navbar-default">
        <div className="navbar-header">
          <a className="navbar-brand navbar-brand-center" href="/">
            SCG Packaging
          </a>
          <button
            className="navbar-toggler collapsed visible-xs-block"
            onClick={onClickCollapse("isActiveSidebar")}
            type="button"
            data-toggle="collapse"
            data-target="#sidenav"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="bars">
              <span className="bar-line bar-line-1 out"></span>
              <span className="bar-line bar-line-2 out"></span>
              <span className="bar-line bar-line-3 out"></span>
            </span>
            <span className="bars bars-x">
              <span className="bar-line bar-line-4"></span>
              <span className="bar-line bar-line-5"></span>
            </span>
          </button>
          <button
            className="navbar-toggler collapsed visible-xs-block"
            type="button"
            data-toggle="collapse"
            data-target="#navbar"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="arrow-up"></span>
            <span className="ellipsis ellipsis-vertical"></span>
          </button>
        </div>
        <div className="navbar-toggleable">
          <nav id="navbar" className="navbar-collapse collapse">
            <button
              className="sidenav-toggler hidden-xs"
              type="button"
              onClick={onClickCollapse("isActiveSidebarSm")}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="bars">
                <span className="bar-line bar-line-1 out"></span>
                <span className="bar-line bar-line-2 out"></span>
                <span className="bar-line bar-line-3 out"></span>
                <span className="bar-line bar-line-4 in"></span>
                <span className="bar-line bar-line-5 in"></span>
                <span className="bar-line bar-line-6 in"></span>
              </span>
            </button>
            <ul className="nav navbar-nav navbar-right">
              <li className="dropdown hidden-xs">
                <button
                  // onClick={onClickStartSapPoJob}
                  className="navbar-account-btn navbar-sync-btn"
                  title="Synce Sap Po"
                >
                  <i className="icon icon-refresh icon-fw icon-lg"></i>
                </button>
                <span className="account-b">{displayName || "annonymous"}</span>
                <button
                  onClick={logout}
                  className="navbar-account-btn"
                  title="logOut"
                >
                  <i className="icon icon-power-off icon-fw icon-lg"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}
